function documentHeight() {
  window.landscape = window.innerHeight < 480 && window.innerWidth < 1000;

  const classList = window.document.body.classList;
  if (window.landscape) {
    classList.add("mobile-landscape");
  } else {
    classList.remove("mobile-landscape");
  }

  document.documentElement.style.setProperty("--vh", `${window.innerHeight}px`);
}

window.addEventListener("resize", documentHeight);

documentHeight();
